import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderStatusesAdapter = getAdapter({ idFieldName: 'value' });

const orderStatusesSlice = createSlice({
  name: 'orderStatuses',
  initialState: orderStatusesAdapter.getInitialState(),
  reducers: {
    setOrderStatuses: (state, { payload: { orderStatuses } }) => {
      orderStatusesAdapter.setAll(state, orderStatuses);
    },
  },
});

const selectors = orderStatusesAdapter.getSelectors(({ orderStatuses }) => orderStatuses);

export const getOrderStatuses = (state) => selectors.selectAll(state);

export const {
  setOrderStatuses,
} = orderStatusesSlice.actions;

export default orderStatusesSlice.reducer;